import { CLINIC_APPOINTMENT_TYPES, CLINIC_SERVICES_ITEMS_TYPES } from 'src/consumer/constants'

export function isAppointmentListingItemGettingEdited(item) {
  return item?._isEditing
}

export function toggleIsEditingForApptListingItem(item) {
  return { ...item, _isEditing: !item?._isEditing }
}

export function isAppointmentListingItemGettingAdded(item) {
  return item?._isAdding
}

export function buildClinicEventsBasedOnTheDefaultTemplates(
  defaultCAppTypeTemplates,
  allCAppTypes,
) {
  console.log({ defaultCAppTypeTemplates, allCAppTypes })

  return (defaultCAppTypeTemplates || [])?.map((template) => {
    const foundCAppType = (allCAppTypes || [])?.find((appType) =>
      isAppTypePartOfDefTemplate(template, appType),
    )

    console.log({ foundCAppType })
    if (!foundCAppType) {
      console.log('prep')
      return prepareCappTypeFromDefTemplate(template)
    }
    console.log('found it')
    return foundCAppType
  })
}

function isAppTypePartOfDefTemplate(template, appType) {
  return appType?.templateId === template?.id
}

function prepareCappTypeFromDefTemplate(template) {
  let itemsType = template?.itemsType ?? CLINIC_SERVICES_ITEMS_TYPES.single.id

  if (template?.type === CLINIC_APPOINTMENT_TYPES['therapy-packages'].id) {
    itemsType = CLINIC_SERVICES_ITEMS_TYPES.bundle.id
  }
  return {
    templateId: template?.id,
    type: template?.type,
    title: template?.title,
    mode: template?.mode,
    visitType: template?.visitType,
    itemsType,
    duration: template?.duration ?? template?.durationInMins,
    clinicalAssessmentIds:
      template?.clinicalAssessmentIds ?? template?.psychAssessmentIds ?? [],
    iconId: template?.iconId ?? template?.icon ?? undefined,
  }
}
